import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './PanelGroup.scss';
/**
 * @component PanelGroup
 * @since 1.0.0
 */
export function PanelGroup(props) {
    const { style } = Object.assign({ style: 'normal' }, props);
    const className = classNames('panel-group', 'panel-group--' + style, props.className);
    return React.createElement("div", { className: className }, props.children);
}
